import { PolicyConfig } from "./types";

export const PRE_2026_POLICY: PolicyConfig = {
  id: "pre_2026",
  name: "pre-2026 osap",

  // Source: ontario.ca/page/maximum-amounts-of-aid — 2024-25 table
  weeklyMaxSingle: 520,
  weeklyMaxWithDependants: 850,

  // Current system: up to 85% of assessed aid as non-repayable grants
  grantShare: 0.85,
  loanShare: 0.15,

  fixedStudentContribution: 3600,
  studentIncomeExemptionPerTerm: 5600,
  variableStudentContributionRate: 0.80,

  // Source: OSAP Policy Manual — discretionary income approach
  parentBaseLivingAllowance: 28000,
  parentLivingAllowancePerMember: 3000,
  parentDiscretionaryRate: 0.06,

  spouseContributionRate: 0.15,

  assetContributionRate: 0.05,
  assetExemptionFloor: 3000,

  dependantSupportBonus: 1500,

  // Source: OSAP Policy Manual living cost tables
  weeklyLivingAllowance: {
    with_parents: 105,
    on_campus: 175,
    off_campus_regular: 195,
    off_campus_toronto: 230,
  },
};


export const POST_2026_POLICY: PolicyConfig = {
  ...PRE_2026_POLICY,

  id: "post_2026",
  name: "post-2026 osap",

  // Source: ontario.ca/page/maximum-amounts-of-aid — 2025-26 table
  weeklyMaxSingle: 525,
  weeklyMaxWithDependants: 865,

  // Source: Ontario government announcement, confirmed for Fall 2026
  grantShare: 0.25,
  loanShare: 0.75,
};

export const POLICY_VERSIONS = [PRE_2026_POLICY, POST_2026_POLICY];